(function () {
try{

// 私有全局对象
window.wattcycle = {
    debounce, // 防抖
    throttle, // 节流
    loadSplide, // 加载轮播图资源
    loadA11yTabs, // 加载Tab资源
    accordion, // faq折叠函数
    loadSplideExtensions, // 加载轮播图持续轮播资源
    setSplideProgress, // 设置轮播图自动轮播进图条
    loadYoutubeApi, // 加载Youtube暂停视频api
    fetchSection, // 获取section模板
    getLoadingDom, // 获取加载dom
    setLoading, // 设置加载状态
    fetchCartView, // 获取 cart section 模板
    openSideCart, // 打开侧边栏购物车
    initWattCart, // 初始化购物车更新事件
    dynLoadImagesFn, // 动态加载图片
    initShoppingOperation, // 初始化购物操作
}

/**
 * 动态加载图片
 */
function dynLoadImagesFn(ctrName) {
  const dynLoadImages = document.querySelectorAll(ctrName +' [data-dyn-load]');
  if (dynLoadImages.length === 0) return;
  const handleScroll = () => {
    dynLoadImages.forEach(img => {
      let srcToLoad = '';
      const width = window.innerWidth;
      const src = img.getAttribute('data-p-all');
      if (src) {
        srcToLoad = src
      } else {
        if (width > 900) {
          srcToLoad = img.getAttribute('data-p1920');
        } else if (width > 450) {
          srcToLoad = img.getAttribute('data-p900');
        } else {
          srcToLoad = img.getAttribute('data-p450');
        }
      }
      if (srcToLoad) {
        img.src = srcToLoad;
      }
    });
    window.removeEventListener('scroll', handleScroll);
  };
  window.addEventListener('scroll', handleScroll);
}

function localUrl(path) {
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    return window.Shopify.routes.root + path;
  }
  return '/' + path;
}

/**
 * 通用脚本动态加载器
 * @param {string} attrName - 选择器，用于查找带有 data-xxx-src 的隐藏元素
 * @param {string} globalName - 加载成功后 window 上暴露的全局变量名，例如 'Splide'
 * @returns {Promise} - resolve 时返回全局对象，reject 时抛出错误
 */
function loadScriptUtil(attrName, globalName, object = window) {
  // 缓存 Promise，避免重复加载同一个脚本
  if (!window.wattcycle.cache) {
    window.wattcycle.cache = new Map();
  }

  const cacheKey = attrName + '-' + globalName;
  if (window.wattcycle.cache.has(cacheKey)) {
    return window.wattcycle.cache.get(cacheKey);
  }

  const promise = new Promise((resolve, reject) => {
    // 查找隐藏元素获取脚本 URL
    const el = document.querySelector(`[${attrName}]`);
    const src = el ? el.getAttribute(attrName) : '';

    if (!src) {
      return reject(new Error(`未找到脚本 URL: ${attrName}`));
    }

    // 如果全局对象已经存在，直接返回
    if (object[globalName]) {
      return resolve(object[globalName]);
    }

    // 创建并加载 script
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;

    script.onload = () => {
      if (object[globalName]) {
        resolve(object[globalName]);
      } else {
        reject(new Error(`${globalName} 加载成功但 xxx.${globalName} 未定义`));
      }
    };

    script.onerror = () => {
      reject(new Error(`加载脚本失败: ${src}`));
    };

    document.head.appendChild(script);
  });

  // 缓存这个 Promise
  window.wattcycle.cache.set(cacheKey, promise);

  return promise;
};



// 加载轮播脚本
function loadSplide() {
    return loadScriptUtil('data-splide-src', 'Splide')
}
// 加载tab切换脚本
function loadA11yTabs() {
    return loadScriptUtil('data-a11y-tabs-src', 'A11yTabs')
}


// 加载Splide无缝滚动组件
function loadSplideExtensions() {
  if (window.Splide) {
    return loadScriptUtil('data-splide-extension-auto-scroll-src', 'splide');
  }
  return Promise.reject(new Error('splide not loaded'));
}

// 加载tab切换脚本
function loadYoutubeApi() {
    return loadScriptUtil('data-youtube-api-src', 'YT')
}



// 防抖函数
function debounce(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 节流函数
function throttle(fn, delay = 300) {
  let timer = null;
  let lastTime = 0;  

  return function (...args) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn.apply(this, args);
      lastTime = now;
    } else {
      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(this, args);
        lastTime = Date.now();
        timer = null;
      }, delay - (now - lastTime));
    }
  };
}
    
/**
 * 初始化 Accordion（折叠面板）
 * @param {string} accordionSelector - 触发按钮的选择器，默认 '.watt-accordion'
 * @param {Object} options - 可选配置
 * @param {string} options.panelSelector - 面板选择器（相对触发器），默认 'nextElementSibling'
 * @param {string} options.iconSelector - 图标元素选择器，默认 '.watt-toggle-icon'
 * @param {string} options.activeIconAttr - 展开时文字属性，默认 'data-icon-active'
 * @param {string} options.inactiveIconAttr - 收起时文字属性，默认 'data-icon-inactive'
 */

function accordion(
  accordionSelector = '.watt-accordion',
  options = {}
) {
  const {
    panelSelector = 'nextElementSibling',
    accordionItemSelector = '.watt-accordion-item',
  } = options;

  // 获取所有 accordion 按钮
  const accButtons = document.querySelectorAll(accordionSelector);
  accButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      // 切换 active 类
      this.classList.toggle('watt-active');
      // 获取对应的 panel
      let panel;
      if (typeof panelSelector === 'string') {
        // 支持 'nextElementSibling'、'.next-panel' 等选择器
        if (panelSelector === 'nextElementSibling') {
          panel = this.nextElementSibling;
        } else if(accordionItemSelector) {
          panel = this.closest(accordionItemSelector)?.querySelector(panelSelector);
        } else {
          panel = this.querySelector(panelSelector) || this.nextElementSibling;
        }
      } else if (panelSelector instanceof Function) {
        panel = panelSelector(this);
      }
      if (!panel) return;

      // 处理面板展开/收起
      if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
        panel.style.maxHeight = '0px';  // 收起
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';  // 展开
        setParentHeight(panel)
      }
    });
  });
}

function setParentHeight(panel) {
  var updom = panel.parentElement.closest('[data-watt-panel]')
  var curPanelHeight = panel.scrollHeight
  var level = 0
  while (updom && level < 3) {
    updom.style.maxHeight = updom.scrollHeight + curPanelHeight + 'px' 
    updom = updom.parentElement.closest('[data-watt-panel]')
    level++
  }
}




function setSplideProgress(splide) {
  // 1. 每次 slide 移动时强制重启 autoplay
  splide.on('move', function () {
    if (splide.Components.Autoplay) {
      splide.Components.Autoplay.play();
    }
  });
  let rafId = null;
  // 2. autoplay 播放时更新进度
  splide.on('autoplay:playing', function (rate) {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      setData.call(splide, rate);
      rafId = null;
    });
  });
  // 3. 实际更新 CSS 变量的函数
  function setData(rate) {
    this.root.style.setProperty('--progress', `${rate * 100}%`);
  }
}


function fetchSection(productUrl, sectionId) {
  var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
  return fetch(url)
    .then(function(res) {
      if (!res.ok) {
        var error = new Error('Section request failed');
        error.status = res.status;
        error.statusText = res.statusText;
        throw error;
      }
      return res.json();
    })
    .then(function(data) {
      var html = data[sectionId];
      if (!data || !html) {
        var error = new Error('Section HTML not found in response');
        error.code = 'NO_SECTION_HTML';
        error.sectionId = sectionId;
        throw error;
      }
      return html;
    }).catch(err => {
      document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: err }));
    })
};


// 获取loading容器
function getLoadingDom(curContainer) {
  if (!curContainer || !curContainer.querySelector) return null;
  const csName = '.watt-global-btn--loading'
  const btn = curContainer.matches(csName) ? curContainer : curContainer.querySelector(csName);
  return btn;
}

// 设置loading状态
function setLoading(dom, isLoading) {
  if (!dom) return;
  dom.classList.toggle('watt-loading', isLoading);
}



// ----------------------------------------------------
/**
 * 更新购物车数量区域
 */
function fetchCartCount() {
  return fetch(localUrl('cart.js'), {
    credentials: 'same-origin'
  })
    .then(function(response) {
      // 1. 校验 HTTP 状态码
      if (!response.ok) {
        throw new Error(`Cart fetch failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(function(cart) {
      // 2. 安全提取 item_count（完美兼容 item_count 为 0 的情况）
      return cart?.item_count ?? 0;
    })
    .catch(function(err) {
      // 3. 统一处理错误并派发事件
      // 如果是因为 JSON 解析失败，给出更明确的提示
      const errorDetail = err instanceof SyntaxError 
        ? 'Cart response is not valid JSON' 
        : (err.message || 'Unknown cart fetch error');

      document.dispatchEvent(new CustomEvent('watt:fetch:error', { 
        detail: errorDetail 
      }));

      // 4. 保证 Promise 链的完整性，返回兜底值 0
      return 0;
    });
}

function updateCartCountFn(count) {
  var countBox = document.querySelector('[data-cart-count-box]')
  if (!countBox) return;
  if (count > 0) {
      countBox.textContent = count;
      countBox.style.opacity = 1
  } else {
      countBox.textContent = 0;
      countBox.style.opacity = 0
  }
}

function fetchCartCountFn() {
    fetchCartCount().then(updateCartCountFn);
}

// 监听购物车更新
document.addEventListener('update-cart-count', function(e) {
    if(e && e.detail != null && e.detail.count != null) {
      updateCartCountFn(e.detail.count)
    }
})

function updateCartCount(count) {
    const updateCartCountEvent = new CustomEvent('update-cart-count', {detail: { count: count }});
    document.dispatchEvent(updateCartCountEvent);
}
// 初始化购物车数量
document.addEventListener('DOMContentLoaded', function() {
    fetchCartCountFn()
})
// ----------------------------------------------------



// ----------------------------------------------------
// 初始化购物车相关方法

// 清空购物车方法
function clearCart() {
  return fetch(localUrl('cart/clear.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          const msg = data.message || data.description || data.errors || 'Failed to clear cart.';
          throw new Error(msg);
        }
        return data;
      });
    }).catch(err => {
      document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: err }));
    })
}

// 解析HTML字符串为DOM文档
function parseHtmlString(htmlString) {
  if (!htmlString) return null
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc
}

function replaceCartFormSection(cart, curRoot) {
  const section = cart?.sections?.['cart-form-tmp'];
  if (!section || !curRoot) return;
  const doc = parseHtmlString(section);
  if (!doc) return;
  const formDom = doc.querySelector('[data-watt-cart-form-content]');
  if (!formDom) return;
  curRoot.innerHTML = formDom.outerHTML;
  document.dispatchEvent(new CustomEvent('watt:cart:refreshed'));
}

  // 增减购物车商品数量
function changeLine(key, quantity) {
  return fetch(localUrl('cart/change.js'), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: key,
      quantity: quantity,
      sections: ['cart-form-tmp'],
      sections_url: localUrl('')
    })
  })
    .then(function (response) {
      // 先把 JSON 解析出来（返回 Promise）
      return response.json().then(function (data) {
        // 这里 response {status, message, description} 
        if (!response.ok) {
          var msg = data.message || data.description || 'Network response was not ok';
          throw new Error(msg);
        }
        return data;
      });
    })
    .then(function (cart) {
      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      return cart;
    })
    .catch(function (error) {
      console.error('Error updating cart line:', error);
      if(window.wattToast) {
        if(error.message) {
          window.wattToast('warning', error.message);
        } else {
          window.wattToast('error', 'Failed to update cart line. Please try again.');
        }
      }
      document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: error }));
      throw error;
    });
}


// 清空购物车方法
function clearCartFn(root, formRoot) {
  // 基础防御：root / formRoot 必须是 Element，且 wattcycle 存在
  if (
    !root ||
    !(root instanceof Element) ||
    !formRoot ||
    !(formRoot instanceof Element) ||
    !window.wattcycle
  ) {
    return;
  }

  const cartBox = formRoot;
  const clearCartBtn = root.querySelector('[data-watt-cart-clear-btn]');
  if (!clearCartBtn) return;

  // 避免重复绑定：如果已经有标记，可以选择先移除或直接 return
  // 这里用 dataset 做一个简单标记（可选）
  if (clearCartBtn.dataset.wattClearBound === 'true') {
    return;
  }
  clearCartBtn.dataset.wattClearBound = 'true';

  clearCartBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // 防重复点击：如果在 loading 中，直接返回（可选）
    if (clearCartBtn.disabled) return;

    window.wattcycle.setLoading(clearCartBtn, true);
    clearCartBtn.disabled = true;

    clearCart()
      .then(function () {
        cartBox.innerHTML =
          `<div class="watt-cart__item--empty">` +
          `${clearCartBtn.dataset.emptyCartText || 'Your cart is empty'}` +
          `</div>`;

        // 购物车数量同步为 0
        if (typeof updateCartCount === 'function') {
          updateCartCount(0);
        }
      })
      .catch(function (error) {
        if (window.wattToast) {
          window.wattToast(
            'error',
            (error && error.message) || 'Failed to clear cart.',
          );
        }
      })
      .finally(function () {
        window.wattcycle.setLoading(clearCartBtn, false);
        clearCartBtn.disabled = false;

        if (window.wattPushbar) {
          setTimeout(() => {
            window.wattPushbar.close('right');
          }, 500);
        }
      });
  });
}


// 初始化购物车方法
function initWattCart(root) {
  if (!root || !(root instanceof Element)) return;
  root.dataset.wattCartInited = 'true';
  const cartBox = root.querySelector('[data-watt-cart-form]');
  if (!cartBox) return;
  clearCartFn(root, cartBox);

  function afterFn(e, dom) {
    if (!window.wattcycle) return;
    if(e && e.item_count != null) {
      updateCartCount(e.item_count);
    }
    window.wattcycle.setLoading(dom, false);
  }

  function beforeFn(dom) {
    if (!window.wattcycle) return;
    window.wattcycle.setLoading(dom, true);
  }

  cartBox.addEventListener('click', function (event) {
    const minusBtn = event.target.closest('[data-qty-minus]');
    const plusBtn = event.target.closest('[data-qty-plus]');
    const removeBtn = event.target.closest('[data-remove-line]');
    const row = event.target.closest('[data-line]');
    if (!row) return;
    const key = row.dataset.line;
    const qtyInput = row.querySelector('[data-cart-quantity-input]');
    if (!qtyInput) return;

    let currentQty = parseInt(qtyInput.value, 10) || 0;

    if (minusBtn) {
      const step = parseFloat(qtyInput.step) || 1;
      // 先把目标数量算出来，允许到 0
      const rawNewQty = Math.max(currentQty - step, 0);
      // 再按规则对齐，但允许 0 直接返回 0（用于删除行）
      const newQty = alignToInputRules(qtyInput, rawNewQty, { allowZero: true });
      beforeFn(minusBtn);
      changeLine(key, newQty).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, minusBtn);
      }).catch(function(res) {
        afterFn(null, minusBtn);
      });
      return;
    }

    if (plusBtn) {
      const step = parseFloat(qtyInput.step) || 1;
      const rawNewQty = currentQty + step;
      const newQty = alignToInputRules(qtyInput, rawNewQty);
      beforeFn(plusBtn);
      changeLine(key, newQty).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, plusBtn);
      }).catch(function(res) {
        afterFn(null, plusBtn);
      });
      return;
    }

    if (removeBtn) {
      beforeFn(removeBtn);
      changeLine(key, 0).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, removeBtn);
      }).catch(function(res) {
        afterFn(null, removeBtn);
      });
      return;
    }
  });

  cartBox.addEventListener('change', function (event) {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    const row = input.closest('[data-line]');
    if (!row) return;

    const key = row.dataset.line;

    // 原始输入值
    const rawValue = input.value;

    // 对齐数量规则：允许 0（删除）
    const alignedQty = alignToInputRules(input, rawValue, { allowZero: true });

    // 同步回 input，避免显示和实际提交不一致
    input.value = alignedQty;

    changeLine(key, alignedQty).then(function (res) {
      replaceCartFormSection(res, cartBox);
    })
  })


  cartBox.addEventListener('blur', function (event) {
    const textarea = event.target.closest('.watt-cart__note-textarea');
    if (!textarea) return;
    updateCartInfo({ note: textarea.value });
  }, true);

  document.dispatchEvent(new CustomEvent('watt:cart:initialized'))
}

// 更新购物车信息
function updateCartInfo(data) {
  fetch(localUrl('cart/update.js'), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(function (response) {
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      return response.json();
    })
    .then(function (cart) {
      console.log('Cart Info updated');
    })
    .catch(function (error) {
      console.error('Error updating cart info:', error);
      document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: error }));
    });
}


// 获取购物车section
function fetchCartView() {
  return fetch(localUrl('cart?section_id=cart-form-wrap'), {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then((res) => {
        var error = new Error(res.message || 'Cart request failed');
        throw error;
      });
    }
    return response.text()
  }).catch(err => {
    window.location.href = localUrl('cart');
    document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: err }));
  })

}

// 打开侧边栏购物车
function openSideCart(html) {
  if (window.wattPushbar) {
      window.wattPushbar.open('right', html, function(target) {
          if(window.wattcycle) {
            window.wattcycle.initWattCart(target)
          }
      })
  }
}

// -------------------------------------


// 更新数量函数
function updateQty(root, newQty) {
  const qtyInputs = root.querySelectorAll('[data-watt-qty-input]');
  qtyInputs.forEach(input => {
    input.value = newQty;
  });
}


// Add to cart — 纯提交逻辑
function submitAtc(form, openCart = false) {
  return new Promise((resolve, reject) => {
    // 全局 loading 开始
    document.dispatchEvent(new CustomEvent('watt:atc:loading'));
    const formData = new FormData(form);
    formData.append('sections', 'cart-count,cart-form-wrap');
    // formData.append('sections', 'cart-form-wrap');
    formData.append('sections_url', localUrl(''));
    fetch(localUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(response => {
        // 先把 JSON 解析出来
        return response.json().then(function (data) {
          if (!response.ok) {
            // 失败时事件（如果你也想在事件里拿到 data，可以一起丢进去）
            document.dispatchEvent(new CustomEvent('watt:cart:item-not-added', {
              detail: {
                message: form.dataset.errorMessage || '✗',
                response: data
              }
            }));

            // Promise 失败
            reject(data);
            // 同时返回一个拒绝的 Promise（符合链式习惯）
            return Promise.reject(data);
          }

          // 成功时事件，detail.response 是真实数据
          document.dispatchEvent(new CustomEvent('watt:cart:item-added', {
            detail: {
              message: form.dataset.successMessage || '✓',
              response: data,   // 这里是解析后的 JSON，不是 Promise
              openCart: openCart
            }
          }));

          resolve(data);
          return data;
        });
      })
      .catch(err => {
        document.dispatchEvent(new CustomEvent('watt:cart:item-not-added', {
          detail: { message: form.dataset.errorMessage || '✗' }
        }));
        document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: err }));
        reject(err);
      })
      .finally(() => {
        // 全局 loading 结束
        document.dispatchEvent(new CustomEvent('watt:atc:done'));
      });
  });
}

// 解析购物车数量函数
function parseCartCountSection(data) {
  // 默认数量为 0
  let cartCount = 0;

  if (!data || !data.sections || !data.sections['cart-count']) {
    return cartCount;
  }

  const htmlString = data.sections['cart-count'];
  const doc = parseHtmlString(htmlString);

  if (!doc) {
    return cartCount;
  }

  const countElement = doc.querySelector('[data-cart-count-box]');
  if (!countElement || typeof countElement.textContent !== 'string') {
    return cartCount;
  }

  const text = countElement.textContent.trim();
  const parsed = parseInt(text, 10);

  // 防止 NaN 污染，保持返回 number 类型
  if (!isNaN(parsed)) {
    cartCount = parsed;
  }
  return cartCount;
}


// 纯函数：根据 min / max / step 对一个给定值进行对齐
function alignQuantity(value, min, max, step, options = {}) {
  const { allowZero = false } = options;

  const safeMin = typeof min === 'number' && !isNaN(min) ? min : 1;
  const safeStep = typeof step === 'number' && !isNaN(step) && step > 0 ? step : 1;
  const safeMax = typeof max === 'number' && !isNaN(max) ? max : Infinity;

  let newValue = parseFloat(value);

  // 1. 处理 NaN
  if (isNaN(newValue)) {
    newValue = safeMin;
  }

  // 特殊处理：允许 0 的场景
  if (allowZero && newValue <= 0) {
    // 这里直接返回 0，不再按 min/step 对齐
    return 0;
  }

  // 2. clamp 到 [min, max] 范围
  if (newValue < safeMin) newValue = safeMin;
  if (newValue > safeMax) newValue = safeMax;

  // 3. 按 step 对齐（基于 min 偏移）
  const offset = newValue - safeMin;
  const remainder = offset % safeStep;

  if (remainder !== 0) {
    newValue = newValue - remainder;
    if (newValue < safeMin) {
      newValue = safeMin;
    }
  }

  return newValue;
}


// 对齐函数
function alignToInputRules(qtyInput, value, options = {}) {
  const min = parseFloat(qtyInput.min) || 1;
  const maxAttr = qtyInput.max;
  const max = maxAttr === '' || maxAttr === undefined ? Infinity : parseFloat(maxAttr);
  const step = parseFloat(qtyInput.step) || 1;

  return alignQuantity(value, min, max, step, options);
}

  

// 添加完成后打开购物车
function wattAddedOpenCart() {
  // 如果 wattcycle 不存在，直接跳转购物车页
  if (!window.wattcycle) {
    window.location.href = localUrl('cart');
    return;
  }

  const hasPushbar = !!window.wattPushbar;
  const cartHtml = window.wattcycle.cartHTML;

  // 封装一个通用的“打开侧边购物车”逻辑
  const openSideCartWithDelay = (html) => {
    if (!html) {
      // 没有 HTML 的情况下，直接跳转到购物车页，防御性处理
      window.location.href = localUrl('cart');
      return;
    }

    if (hasPushbar) {
      window.wattPushbar.close('right');
      setTimeout(() => {
        window.wattcycle.openSideCart(html);
      }, 500);
    } else {
      // 没有 pushbar 时不做侧边抽屉，直接跳转购物车页
      window.location.href = localUrl('cart');
    }
  };

  // 如果已经有缓存的 cartHTML，直接用
  if (cartHtml != null) {
    openSideCartWithDelay(cartHtml);
    return;
  }

  // 否则发请求获取 cart 视图
  window.wattcycle.fetchCartView()
    .then((html) => {
      // 有 pushbar 时先收起右侧，再打开
      if (hasPushbar) {
        window.wattPushbar.close('right');
      }
      setTimeout(() => {
        window.wattcycle.openSideCart(html);
      }, 500);
    })
    .catch((error) => {
      // 请求失败时，退回到普通 cart 页面
      window.location.href = localUrl('cart');
    });
}

// 设置购物车 HTML, 用于后续打开购物车
function setCartHTML(response) {
  if (!response || !response.sections || !response.sections['cart-form-wrap']) return
  const html = response.sections['cart-form-wrap'] || null
  const doc = parseHtmlString(html)
  if(!doc || !doc.body || !doc.body.innerHTML) return
  window.wattcycle.cartHTML = doc.body.innerHTML
}

// 加购成功
document.addEventListener('watt:cart:item-added', function(data) {
  if (data && data.detail) {
    if (data.detail.response) {
      const res = data.detail.response
      const cartCount = parseCartCountSection(res)
      updateCartCount(cartCount)
      setCartHTML(res)
    }
    if(data.detail.openCart){
      wattAddedOpenCart()
    }
    if (window.wattToast) {
      window.wattToast('success', data.detail.message)
    }
  }
})

// 加购失败
document.addEventListener('watt:cart:item-not-added', function(data) {
  if (!data || !data.detail) return;
  if (window.wattToast) {
    window.wattToast('warning', data.detail.message)
  }
})

// 未选变体
document.addEventListener('watt:cart:item-not-var', function(data) {
  if (!data || !data.detail) return;
  if (window.wattToast) {
    window.wattToast('warning', data.detail)
  }
})

// ------------------------------------

// 初始化购物车成功
document.addEventListener('watt:cart:initialized', function(data) {
  if (window.wattcycle && typeof window.wattcycle.accordion === 'function') {
    window.wattcycle.accordion('.watt-cart__note-label');
  }
})

// 购物车更新成功
document.addEventListener('watt:cart:refreshed', function(data) {
  if (window.wattcycle && typeof window.wattcycle.accordion === 'function') {
    window.wattcycle.accordion('.watt-cart__note-label');
  }
})




// -------------------------------
// 选项变化：修正后续选项，然后寻找完整匹配的可售变体
document.addEventListener('watt:prod:var:option:change', function (event) {
  const root = event.detail?.root;
  if (!root) return;

  const variants = getVariantsJsonArr(root);
  if (!Array.isArray(variants) || !variants.length) return;

  const changedIndex = event.detail.changedIndex ?? -1;

  fixInvalidSelectionsFromIndex(root, variants, changedIndex);

  const values = readVariantValues(root, variants[0].options.length);

  const selectedVariant = variants.find(variant =>
    variant.available === true &&
    variant.options.every((value, index) => value === values[index])
  ) || null;

  document.dispatchEvent(new CustomEvent('watt:prod:var:changed', {
    detail: { selectedVariant, root }
  }));
});

// 变体id改变,中间处理事件
document.addEventListener('watt:prod:var:id:change', function(data) {
  if (data && data.detail) {
    const root = data.detail.root || null
    const selectedData = data.detail.selectedData || null
    if (!root || !selectedData) return;
    const selectedVariant = getSelectVariantById(getVariantsJsonArr(root), selectedData)
    document.dispatchEvent(new CustomEvent('watt:prod:var:changed', {
        detail: {
            selectedVariant,
            root, 
        }
    }));
  }
})

// 变体确定后，同步商品信息
document.addEventListener('watt:prod:var:changed', function (event) {
  const { selectedVariant, root } = event.detail || {};
  if (!root) return;
  // 无可售变体时禁用加购，避免提交旧 ID
  const buttons = root.querySelectorAll('[data-watt-atc-button]');

  buttons.forEach(button => {
    button.disabled = !selectedVariant?.available;
    button.setAttribute(
      'aria-disabled',
      String(!selectedVariant?.available)
    );
  });

  if (!selectedVariant) {
    const input = root.querySelector('[data-watt-var-id-input]');
    if (input) input.value = '';

    refreshVar(null, root);
    return;
  }

  // 先同步选中，再刷新可用状态
  setSelectedVariant(selectedVariant, root);
  refreshVar(selectedVariant, root);

  setProdPrice(selectedVariant, root);
  setSubmitInput(selectedVariant, root);
  setInputMinMaxNum(selectedVariant, root);
});

// 按选项索引读取当前选择，不依赖 input 的 name 格式
function readVariantValues(root, count) {
  return Array.from({ length: count }, (_, index) => {
    const input = root.querySelector(
      `input[data-watt-option-index="${index}"]:checked`
    );

    return input ? input.value : null;
  });
}



// 获取变体json数组
function getVariantsJsonArr(root) {
  if (!root) return null;

  const variantsCtr = root.querySelector('[data-watt-variants]');
  if (!variantsCtr) return null;

  try {
    const jsonString = variantsCtr.getAttribute('data-watt-variants');
    if (!jsonString) return null;

    // 防御性处理：去除首尾空白和可能存在的 BOM 头
    const cleanString = jsonString.trim().replace(/^\uFEFF/, '');
    if (!cleanString) return null;

    const data = JSON.parse(cleanString);

    // 缓存到 root 上，后续复用
    root._wattProdVariantsObj = data;

    return data;
  } catch (err) {
    // 捕获 SyntaxError，避免程序崩溃
    console.error('JSON 解析失败:', err);
    return null; // 返回一个安全的默认值
  }
}

// 通过变体id获取变体对象
function getSelectVariantById(variantsJsonArr, varId) {
    if(!variantsJsonArr || !varId) return null
    const selectedVariant = variantsJsonArr.find(variant => {
        if(variant.id && varId && variant.id == varId) return true
    });
    return selectedVariant
}


// 刷新选项可用状态：只受前面的维度约束
function refreshVar(selectedVariant, root) {
  if (!root) return;

  const variants = getVariantsJsonArr(root);
  if (!Array.isArray(variants) || !variants.length) return;

  const count = variants[0].options.length;
  const values = readVariantValues(root, count);

  for (let index = 0; index < count; index++) {
    const inputs = root.querySelectorAll(
      `input[data-watt-option-index="${index}"]`
    );

    inputs.forEach(input => {
      const available = variants.some(variant =>
        variant.available === true &&
        variant.options[index] === input.value &&
        variant.options.slice(0, index).every((value, previousIndex) =>
          values[previousIndex] == null ||
          value === values[previousIndex]
        )
      );

      input.disabled = !available;

      if (available) {
        input.removeAttribute('aria-disabled');
      } else {
        input.setAttribute('aria-disabled', 'true');
      }
    });
  }
}


// 从改变维度的下一维开始，依次修正无效选择
// startIndex = -1 时，从第 0 维开始检查
function fixInvalidSelectionsFromIndex(root, variants, startIndex) {
  const count = variants[0].options.length;

  refreshVar(null, root);

  for (
    let index = Math.max(0, startIndex + 1);
    index < count;
    index++
  ) {
    const inputs = Array.from(root.querySelectorAll(
      `input[data-watt-option-index="${index}"]`
    ));

    // 当前选择仍然可用，则保留
    if (inputs.some(input => input.checked && !input.disabled)) {
      continue;
    }

    // 否则选中第一个可用值；无可用值则全部取消
    const firstEnabled = inputs.find(input => !input.disabled);

    inputs.forEach(input => {
      input.checked = input === firstEnabled;
    });

    // 每修改一维，立即刷新后面的可用状态
    refreshVar(null, root);
  }
}

// 设置选中的变体
// 遍历变体选项, 找到匹配的input, 并设置为checked中
function setSelectedVariant(selectedVariant, root) {
    if(selectedVariant && root) {
        selectedVariant.options.forEach((option, index) => {
            const targetVarInput = root.querySelector(`input[value="${option}"][data-watt-option-index="${index}"]`)
            if(targetVarInput) {
                targetVarInput.checked = true
            }
        })
    }
}

// 设置商品价格, 包含销售价格和对比价格
function setProdPrice(selectedVariant, root) {
    if(!selectedVariant || !root) return
    const priceEls = root.querySelectorAll('[data-watt-sale-price]')
    const comparePriceEls = root.querySelectorAll('[data-watt-regular-price]')
    const variantId = selectedVariant.id
    if(variantId) {
        const tmpPriceEl = root.querySelector(`template[data-watt-var-id="${variantId}"]`)
        if(tmpPriceEl) {
            const salePrice = tmpPriceEl.getAttribute('data-watt-var-price')
            const comparePrice = tmpPriceEl.getAttribute('data-watt-compare-price')
            if(priceEls.length > 0) {
                priceEls.forEach(priceEl => {
                    priceEl.innerHTML = salePrice
                })
            }
            if(comparePriceEls.length > 0) {
                comparePriceEls.forEach(comparePriceEl => {
                    if (comparePrice) {
                        comparePriceEl.innerHTML = comparePrice
                        comparePriceEl.hidden = false;
                    } else {
                        comparePriceEl.hidden = true;
                    }
                })
            } 
        }
    }
}

// 设置提交input的值, value为变体id
function setSubmitInput(selectedVariant, root) {
    if(!selectedVariant || !root) return
    const variantInput = root.querySelector('[data-watt-var-id-input]');
    if(!variantInput) return
    const variantId = selectedVariant.id || null
    if(variantId) {
        variantInput.value = variantId;
    }
}
    
// 设置购买数量输入框的最小值、最大值和步进值
function setInputMinMaxNum(selectedVariant, root) {
  if (!selectedVariant || !root) return;

  const qtyRule = selectedVariant.quantity_rule;
  if (!qtyRule) return;

  const qtyInputs = root.querySelectorAll('[data-watt-qty-input]');
  if (!qtyInputs || qtyInputs.length === 0) return;

  qtyInputs.forEach((qtyInput) => {
    if (!qtyInput) return;

    const currentValue = parseFloat(qtyInput.value);

    // 1. 应用变体的数量规则到 input 属性
    let min, max, step;

    if (qtyRule.min != null && typeof qtyRule.min === 'number' && qtyRule.min >= 1) {
      min = qtyRule.min;
      qtyInput.min = qtyRule.min;
    } else {
      min = 1;
      qtyInput.min = 1;
    }

    if (qtyRule.max != null && typeof qtyRule.max === 'number' && qtyRule.max >= min) {
      max = qtyRule.max;
      qtyInput.max = qtyRule.max;
    } else {
      max = Infinity;
      qtyInput.removeAttribute('max');
    }

    if (qtyRule.increment != null && typeof qtyRule.increment === 'number' && qtyRule.increment >= 1) {
      step = qtyRule.increment;
      qtyInput.step = qtyRule.increment;
    } else {
      step = 1;
      qtyInput.step = 1;
    }

    // 2. 使用公共对齐函数修正当前 value
    const alignedValue = alignQuantity(currentValue, min, max, step);
    qtyInput.value = alignedValue;
  });
}


// -------------------------------------------------

// 购买数量输入框输入事件
document.addEventListener('watt:prod:qty:input', function(data) {
    if (!data || !data.detail) return;
    const qtyInput = data.detail.eventDom || null;
    const root = data.detail.root || null;
    if (!qtyInput || qtyInput.tagName.toLowerCase() !== 'input' || qtyInput.value == null) {
        return;
    }
    const qty = qtyInput.value;
    updateQty(root, alignToInputRules(qtyInput, qty));
});

// 点击购买数量按钮事件
document.addEventListener('watt:prod:qty:click', function (event) {
  const detail = event && event.detail;
  if (!detail) return;

  const root = detail.root || null;
  const qtyBox = detail.qtyBox || null;
  const eventDom = detail.eventDom || null;

  if (!qtyBox || !eventDom) return;
  if (eventDom.tagName.toLowerCase() !== 'button') return;

  const qtyInput = qtyBox.querySelector('[data-watt-qty-input]');
  if (!qtyInput) return;

  const btnType = eventDom.getAttribute('data-watt-qty-button-type');
  if (!btnType) return;

  const BUTTON_TYPE = {
    MINUS: 'minus',
    PLUS: 'plus',
  };

  const min = parseFloat(qtyInput.min) || 1;
  const step = parseFloat(qtyInput.step) || 1;
  const current = parseFloat(qtyInput.value || min);

  let qty = current;

  if (btnType === BUTTON_TYPE.MINUS) {
    // 按 step 减
    qty = current - step;
    // 对齐规则（包含 min / max / step）
    qty = alignToInputRules(qtyInput, qty);
    // 避免不断点击减号出现 0 或负数
    if (qty < min) qty = min;
  } else if (btnType === BUTTON_TYPE.PLUS) {
    // 按 step 加
    qty = current + step;
    // 对齐规则（包含 min / max / step）
    qty = alignToInputRules(qtyInput, qty);
  } else {
    // 未知类型，直接返回，避免未来扩展出现问题
    return;
  }

  updateQty(root, qty);
});


// ---------------------------------
// 点击添加到购物车按钮事件
document.addEventListener('watt:prod:atc:click', function (event) {
  if (!event || !event.detail) return;
  const atcBtn = event.detail.atcBtn || null;
  const root = event.detail.root || null;
  if (!atcBtn || !root) return;
  const form = root.querySelector('[data-watt-atc-form]');
  if (!form) return;
  const variantInput = root.querySelector('[data-watt-var-id-input]');
  if (!variantInput || !variantInput.value) {
    const selectVariantText = (form.dataset && form.dataset.selectVariantText) || 'Please select an option.';
    document.dispatchEvent(
      new CustomEvent('watt:cart:item-not-var', {
        detail: selectVariantText,
      }),
    );
    return;
  }

  submitAtc(form, true).then(() => {});
});


// --------------------------------------------------------------
// 初始化购物操作
function initShoppingOperation(root) {
  if(!root) return
  // 监听加入购物车按钮点击事件
  const atcBtns = root.querySelectorAll('[data-watt-atc-button]')
  if (atcBtns.length > 0) {
    atcBtns.forEach(atcBtn => {
      atcBtn.addEventListener('click', e => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('watt:prod:atc:click', {
              detail: {
                  atcBtn,
                  root
              }
          }))
      });
      bindAtcButtonLoading(atcBtn);
    })
  }

  // 监听数量盒子事件
  const qtyBoxs = root.querySelectorAll('[data-watt-qty-box]')
  if(qtyBoxs) {
      qtyBoxs.forEach(qtyBox => {
          qtyBox.addEventListener('input', e => {
              document.dispatchEvent(new CustomEvent('watt:prod:qty:input', {
                  detail: {
                      eventDom: e.target,
                      root,
                  }
              }))
          })
          qtyBox.addEventListener('click', e => {
              document.dispatchEvent(new CustomEvent('watt:prod:qty:click', {
                  detail: {
                      eventDom: e.target,
                      qtyBox, 
                      root,
                  }
              }))
          })
      })
  }
  
  // 监听变体切换事件
    bindVariantSelection(root)
}

// 绑定变体选项事件
function bindVariantSelection(root) {
  const variantsCtr = root.querySelector('[data-watt-variants]');

  if (
    !variantsCtr ||
    variantsCtr.dataset.wattVariantBound === 'true'
  ) {
    return;
  }

  variantsCtr.dataset.wattVariantBound = 'true';

  variantsCtr.addEventListener('change', event => {
    const target = event.target;
    if (!target.matches('[data-watt-var-item]')) return;

    const changedIndex = Number(
      target.getAttribute('data-watt-option-index')
    );

    if (!Number.isInteger(changedIndex) || changedIndex < 0) return;

    document.dispatchEvent(new CustomEvent('watt:prod:var:option:change', {
      detail: {
        root,
        changedIndex
      }
    }));
  });

  initVariantSelection(root, variantsCtr);
}

// 初始化：保留当前可售组合，否则选择第一个可售变体
function initVariantSelection(root, variantsCtr) {
  if (!root || !variantsCtr) return;

  const variants = getVariantsJsonArr(root);
  if (!Array.isArray(variants) || !variants.length) return;

  const values = readVariantValues(root, variants[0].options.length);

  const current = variants.find(variant =>
    variant.available === true &&
    variant.options.every((value, index) => value === values[index])
  );

  const target =
    current || variants.find(variant => variant.available === true);

  if (target) {
    setSelectedVariant(target, root);
  }

  document.dispatchEvent(new CustomEvent('watt:prod:var:option:change', {
    detail: {
      root,
      changedIndex: -1
    }
  }));
}

// 绑定加入购物车按钮加载状态
function bindAtcButtonLoading(loadingDom) {
  if (!loadingDom || !window.wattcycle) return;
  if (loadingDom.dataset.wattAtcBinded === 'true') return;
  loadingDom.dataset.wattAtcBinded = 'true';
  
  document.addEventListener('watt:atc:loading', () => {
    window.wattcycle.setLoading(loadingDom, true);
    loadingDom.setAttribute('aria-disabled', 'true');
  });
  document.addEventListener('watt:atc:done', () => {
    window.wattcycle.setLoading(loadingDom, false);
    loadingDom.setAttribute('aria-disabled', 'false');
  });
}

// 全局统一监听 fetch 错误事件
document.addEventListener('watt:fetch:error', function (event) {
  var error = event && event.detail;
  if (!error) return;
  var msg = String(error); 

  // 只要字符串里包含 "SyntaxError TypeError" 就刷新页面
  if (msg.indexOf('SyntaxError') !== -1 || msg.indexOf('TypeError') !== -1) {
    window.location.reload();
  }
});

} catch(e) { console.log(e) }
})();